<template>
  <!-- 210304 | id 추가 -->
  <section
    id="services"
    class="services"
  >
    <div class="services__inner">
      <h2 class="title title--services">
        우리가 가진 기술들
      </h2>
      <h5 class="description description--services">
        UI Lab은 퍼포먼스 향상을 위한 멋진 프래임웍과 툴을 사용 합니다
      </h5>
      <div class="services__iconWrap">
        <ul class="services__iconrow">
          <li
            v-for="(item, index) in skills"
            :key="index"
            class="services__iconcolumn"
          >
            <img
              :src="`/content/images/${item.image}`"
              :title="`${item.title}`"
              :alt="`${item.title}`"
              class="services__img"
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
export default {
	name: 'Skill',
	data() {
    return {
      skills: []
		} 
  },
  computed: {
	},
  watch: {},
  created() {
		this.getData()
	},
  mounted() {
	},
  methods: {
		getData() {
			axios.get(`${process.env.BASE_URL}data/skill.json`)
				.then(response => {
					this.skills = response.data
				})
				.catch(error => {
					this.$eventHub.$emit('showError', error)
				})
				.then(() => {
				})
		}
	}
}
</script>

<style lang="scss" scoped>
// [s] 210304 | css 수정
.services {
  $self:&;
  background-color: #f0f0f3;
  width:100%;
  padding:100px 0 112px 0;
  &__inner{
    width:900px;
    margin:0 auto;
    text-align:center;
  }
  &__iconWrap{
    padding-top:60px;
    display:flex;
    -ms-flexbox:flexbox;
    flex-flow:column wrap;
  }
  &__iconrow{
    margin: -25px 0;
    display: flex;
    flex-wrap: wrap;
  }
  &__iconcolumn{
    margin: 25px 0;
    width: 14.285%;
  }
}
// [e] | 210304 css 수정
</style>